export const mapUserDetailsToContactInfo = (userDetails) => {
    return {
        salutation: getSalutation(userDetails.salutation),
        firstName: userDetails.firstname,
        lastName: userDetails.surname,
        email: userDetails.email,
        phone: userDetails.phone
    };
};
const getSalutation = (salutation) => {
    if (typeof salutation === "string") {
        const parsed = parseInt(salutation, 10);
        return isNaN(parsed) ? null : parsed;
    }
    return null;
};
//# sourceMappingURL=mapUserDetailsToContactInfo.js.map
